module.exports = __webpack_public_path__ + "img/icon_exam_order.ac693502.png";